/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Video_Camera_NumberInputs */

const th_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กล้อง ${i?.number}`)
};

const en_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera ${i?.number}`)
};

const ja_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`カメラ ${i?.number}`)
};

const zh_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`摄像头 ${i?.number}`)
};

const es_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cámara ${i?.number}`)
};

const pt_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Câmera ${i?.number}`)
};

const id_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const fr_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caméra ${i?.number}`)
};

const tl_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera ${i?.number}`)
};

const vi_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Máy ảnh ${i?.number}`)
};

const ko_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`카메라 ${i?.number}`)
};

const de_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const ru_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Камера ${i?.number}`)
};

const tr_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const it_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fotocamera ${i?.number}`)
};

const pl_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const uk_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Камера ${i?.number}`)
};

const hi_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कैमरा ${i?.number}`)
};

const ar_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الكاميرا ${i?.number}`)
};

const ms_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const bn_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ক্যামেরা ${i?.number}`)
};

const zh_tw2_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相機 ${i?.number}`)
};

const zh_hk2_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相機 ${i?.number}`)
};

const ur_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`کیمرا ${i?.number}`)
};

const fa_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دوربین ${i?.number}`)
};

const sw_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kamera ${i?.number}`)
};

const nl_video_camera_number = /** @type {(inputs: Video_Camera_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Camera ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Camera {number}" |
*
* @param {Video_Camera_NumberInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera_number = /** @type {((inputs: Video_Camera_NumberInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Camera_NumberInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera_number(inputs)
	if (locale === "ja") return ja_video_camera_number(inputs)
	if (locale === "zh") return zh_video_camera_number(inputs)
	if (locale === "es") return es_video_camera_number(inputs)
	if (locale === "pt") return pt_video_camera_number(inputs)
	if (locale === "id") return id_video_camera_number(inputs)
	if (locale === "fr") return fr_video_camera_number(inputs)
	if (locale === "tl") return tl_video_camera_number(inputs)
	if (locale === "vi") return vi_video_camera_number(inputs)
	if (locale === "ko") return ko_video_camera_number(inputs)
	if (locale === "de") return de_video_camera_number(inputs)
	if (locale === "ru") return ru_video_camera_number(inputs)
	if (locale === "tr") return tr_video_camera_number(inputs)
	if (locale === "it") return it_video_camera_number(inputs)
	if (locale === "pl") return pl_video_camera_number(inputs)
	if (locale === "uk") return uk_video_camera_number(inputs)
	if (locale === "hi") return hi_video_camera_number(inputs)
	if (locale === "ar") return ar_video_camera_number(inputs)
	if (locale === "ms") return ms_video_camera_number(inputs)
	if (locale === "bn") return bn_video_camera_number(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera_number(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera_number(inputs)
	if (locale === "ur") return ur_video_camera_number(inputs)
	if (locale === "fa") return fa_video_camera_number(inputs)
	if (locale === "sw") return sw_video_camera_number(inputs)
	if (locale === "nl") return nl_video_camera_number(inputs)
	return en_video_camera_number(inputs)
});